if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        /*
         * Get the current mini-cart.
         * We will also re-query this before/after each cart action
         * so we do not rely on an old DOM reference.
         */
        this.cart = this.getCart();

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }


      /*
       * Always return the currently-active mini-cart element.
       */
      getCart() {
        return document.querySelector('mini-cart');
      }


      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add(
          'loading'
        );

        // this.querySelector('.loading__spinner').classList.remove('hidden');


        const config =
          fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];


        const formData =
          new FormData(this.form);


        /*
         * IMPORTANT:
         * Re-query the mini-cart before every request.
         */
        const currentCart =
          this.getCart();

        this.cart =
          currentCart;


        if (currentCart) {

          if (
            typeof currentCart.getSectionsToRender ===
            'function'
          ) {

            formData.append(
              'sections',
              currentCart
                .getSectionsToRender()
                .map((section) => section.id)
            );

          }


          formData.append(
            'sections_url',
            window.location.pathname
          );


          if (
            typeof currentCart.setActiveElement ===
            'function'
          ) {

            currentCart.setActiveElement(
              document.activeElement
            );

          }

        }


        config.body =
          formData;


        fetch(
          `${theme.routes.cart_add_url}`,
          config
        )

          .then(
            (response) =>
              response.json()
          )

          .then((response) => {

            /*
             * Shopify error response
             */
            if (response.status) {

              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source: 'product-form',

                  productVariantId:
                    formData.get('id'),

                  errors:
                    response.errors ||
                    response.description,

                  message:
                    response.message,
                }
              );


              this.handleErrorMessage(
                response.description
              );


              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );


              if (!soldOutMessage) {
                return;
              }


              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );


              if (this.submitButtonText) {
                this.submitButtonText.classList.add(
                  'hidden'
                );
              }


              soldOutMessage.classList.remove(
                'hidden'
              );


              this.error =
                true;


              return;
            }


            /*
             * Re-query the mini-cart after Shopify
             * has successfully added the product.
             */
            const updatedCart =
              this.getCart();

            this.cart =
              updatedCart;


            /*
             * If there is no mini-cart, fall back
             * to the normal Shopify cart page.
             */
            if (!updatedCart) {

              window.location =
                theme.routes.cart_url;

              return;
            }


            /*
             * IMPORTANT FIX
             *
             * cart.js expects the property:
             *
             *     event.cart
             *
             * The previous product-form.js only supplied:
             *
             *     event.cartData
             *
             * We now provide BOTH so existing apps/theme
             * code expecting either property continues working.
             */
            if (!this.error) {

              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source: 'product-form',

                  productVariantId:
                    formData.get('id'),

                  cart:
                    response,

                  cartData:
                    response,
                }
              );

            }


            this.error =
              false;


            const quickAddModal =
              this.closest(
                'quick-add-modal'
              );


            /*
             * QUICK ADD
             */
            if (quickAddModal) {

              document.body.addEventListener(
                'modalClosed',

                () => {

                  setTimeout(() => {

                    const latestCart =
                      this.getCart();

                    this.cart =
                      latestCart;


                    if (
                      latestCart &&
                      typeof latestCart.renderContents ===
                        'function'
                    ) {

                      latestCart.renderContents(
                        response
                      );

                    }

                  });

                },

                {
                  once: true
                }
              );


              quickAddModal.hide(
                true
              );

            }


            /*
             * NORMAL PRODUCT PAGE ADD TO CART
             */
            else {

              const latestCart =
                this.getCart();

              this.cart =
                latestCart;


              if (
                latestCart &&
                typeof latestCart.renderContents ===
                  'function'
              ) {

                latestCart.renderContents(
                  response
                );

              }

            }

          })

          .catch((e) => {

            console.error(
              'Product add-to-cart error:',
              e
            );

          })

          .finally(() => {

            this.submitButton.classList.remove(
              'loading'
            );


            /*
             * Re-query the cart again after everything
             * has finished rendering.
             */
            const latestCart =
              this.getCart();

            this.cart =
              latestCart;


            if (
              latestCart &&
              latestCart.classList.contains(
                'is-empty'
              )
            ) {

              latestCart.classList.remove(
                'is-empty'
              );

            }


            if (!this.error) {

              this.submitButton.removeAttribute(
                'aria-disabled'
              );

            }


            // this.querySelector('.loading__spinner').classList.add('hidden');

          });
      }


      blockSubmitIfRequiredFieldsEmpty(event) {

        if (
          !(this.form instanceof HTMLFormElement)
        ) {

          throw new Error(
            'Expected a form element.'
          );

        }


        const formId =
          this.form.getAttribute('id');


        const requiredFields =
          document.querySelectorAll(
            '[required]'
          );


        let allFilled =
          true;


        for (
          const field of requiredFields
        ) {

          const belongsToForm =
            field.getAttribute('form') === formId ||
            field.closest('form')?.id === formId;


          if (!belongsToForm) {
            continue;
          }


          let isValid =
            true;


          switch (field.type) {

            case 'checkbox':

            case 'radio': {

              const group =
                document.querySelectorAll(
                  `input[name="${field.name}"][type="${field.type}"]`
                );


              const isChecked =
                Array
                  .from(group)
                  .some(
                    (input) =>
                      input.checked
                  );


              isValid =
                isChecked;


              break;
            }


            case 'select-one':

              isValid =
                field.value !== '';

              break;


            case 'textarea':

            case 'text':

            case 'email':

            case 'number':

            case 'url':

            default:

              isValid =
                field.value.trim() !== '';

              break;
          }


          if (!isValid) {

            allFilled =
              false;


            field.classList.add(
              'invalid'
            );

          }

          else {

            field.classList.remove(
              'invalid'
            );

          }

        }


        if (!allFilled) {

          event.preventDefault();


          this.handleErrorMessage(
            theme
              .accessibilityStrings
              .fillInAllLineItemPropertyRequiredFields
          );


          return false;
        }


        return true;
      }


      handleErrorMessage(
        errorMessage = false
      ) {

        if (this.hideErrors) {
          return;
        }


        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );


        if (
          !this.errorMessageWrapper
        ) {
          return;
        }


        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );


        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );


        if (
          errorMessage &&
          this.errorMessage
        ) {

          this.errorMessage.textContent =
            errorMessage;

        }
      }


      toggleSubmitButton(
        disable = true,
        text
      ) {

        if (disable) {

          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );


          if (
            text &&
            this.submitButtonText
          ) {

            this.submitButtonText.textContent =
              text;

          }

        }

        else {

          this.submitButton.removeAttribute(
            'disabled'
          );


          if (
            this.submitButtonText
          ) {

            this.submitButtonText.textContent =
              theme.variantStrings.addToCart;

          }

        }
      }


      get variantIdInput() {

        return this.form.querySelector(
          '[name=id]'
        );

      }
    }
  );
}